export default __webpack_public_path__ + "static/media/closeIcon.a7846042.svg";